import querystring from 'querystring';
import { AxiosResponse } from 'axios';

import { getStoreProxyUrl } from '../index';
import { IResponse } from '../types';
import {
    IShifts,
    IShiftRequest,
    IPassengerRequest,
    IResponsePassenger,
    ISetShiftOrder,
    IDelShiftOrderApi,
    IPassengerDate,
    ISetPassengersOrders,
    IPassengerShiftUpdate,
    IPayloadDepartments,
    IDepartment,
    IStatistics,
    IPayloadStatistics,
    IDepartmentsStatistics,
    SetPassengersResponseCodes,
} from '../../types/manualOrders/api.types';
import { createPayload, postProxy } from '../utilis';
import { makeApiCall } from '../reportsApi/utils';

// FC REQUEST

export const getShifts = async ({
    proxyUrl,
    dbUrl,
    ...payload
}: IShiftRequest): Promise<AxiosResponse<IResponse<Array<IShifts>>>> => {
    // const data = querystring.stringify({
    //    ...createPayload(payload),
    // });

    // return instance.post(
    //    buildEncriptedUrl(dbUrl, 'ws_MyWayStudio_Get_Shifts_By_Dates'),
    //    data,
    // );
    return makeApiCall<
        IResponse<Array<IShifts>>,
        {
            departmentCode?: number | undefined;
            token: string;
            fromDate: string;
            toDate: string;
            clientCode: number;
        }
    >({
        dbUrl,
        payload,
        endpoint: 'ws_MyWayStudio_Get_Shifts_By_Dates',
    });
};

// FC REQUEST

export const getPassngerShifts = async ({
    proxyUrl,
    dbUrl,
    ...payload
}: IPassengerRequest): Promise<AxiosResponse<IResponsePassenger>> => {
    const data = querystring.stringify({
        ...createPayload(payload),
        webservice: 'ws_MyWayStudio_Get_Passsengers_4_Dates',
    });

    return postProxy<IResponsePassenger>(getStoreProxyUrl(), data);
};

// FC REQUEST

export const setPassngerShifts = async ({
    proxyUrl,
    dbUrl,
    ...payload
}: ISetShiftOrder): Promise<AxiosResponse<IPassengerDate>> => {
    const data = querystring.stringify({
        ...createPayload(payload),
        webservice: 'ws_MyWayStudio_Set_Shift_Order',
    });

    return postProxy<IPassengerDate>(getStoreProxyUrl(), data);
};

// FC REQUEST

export const delPassngerShifts = async ({
    proxyUrl,
    dbUrl,
    ...payload
}: IDelShiftOrderApi): Promise<AxiosResponse<any>> => {
    const data = querystring.stringify({
        ...createPayload(payload),
        webservice: 'ws_MyWayStudio_Del_Orders',
    });

    return postProxy<any>(getStoreProxyUrl(), data);
};

// FC REQUEST

export const setPassengersOrders = async ({
    proxyUrl,
    dbUrl,
    jsonData,
    clientCode,
    ...rest
}: ISetPassengersOrders): Promise<
    AxiosResponse<{
        message: IPassengerShiftUpdate[];
        response: SetPassengersResponseCodes;
    }>
> => {
    const data = querystring.stringify({
        $jsonData: `[${JSON.stringify(jsonData)}]`,
        $clientCode: clientCode,
        $dropCity: rest.dropCity,
        $dropHouseNum: rest.dropHouseNum,
        $dropStreet: rest.dropStreet,
        $pickupCity: rest.pickupCity,
        $pickupHouseNum: rest.pickupHouseNum,
        $pickupStreet: rest.pickupStreet,
        webservice: 'ws_MyWayStudio_Set_Passengers_Orders',
    });

    return postProxy<{ message: IPassengerShiftUpdate[]; response: SetPassengersResponseCodes }>(
        getStoreProxyUrl(),
        data
    );
};

// FC REQUEST

export const getDepartments = async ({
    dbUrl,
    ...payload
}: IPayloadDepartments): Promise<AxiosResponse<{ response: string; departments: IDepartment[] }>> => {
    const data = querystring.stringify({
        ...createPayload(payload),
        webservice: 'ws_MyWayStudio_Get_Departments',
    });

    return postProxy<{ response: string; departments: IDepartment[] }>(getStoreProxyUrl(), data);
};

// FC REQUEST

export const getShiftsStatistics = async ({
    dbUrl,
    ...payload
}: IPayloadStatistics): Promise<
    AxiosResponse<{
        response: string;
        shiftsStatistics: IStatistics[];
        fromDate: string;
        toDate: string;
    }>
> => {
    const data = querystring.stringify({
        ...createPayload(payload),
        webservice: 'Ws_MyWayStudio_Get_Shifts_Statistics',
    });

    return postProxy<{ response: string; shiftsStatistics: IStatistics[]; fromDate: string; toDate: string }>(
        getStoreProxyUrl(),
        data
    );
};

// FC REQUEST

export const getDepartmentsStatistics = async ({
    dbUrl,
    ...payload
}: IPayloadStatistics): Promise<
    AxiosResponse<{
        response: string;
        departmentsStatistics: IDepartmentsStatistics[];
        fromDate: string;
        toDate: string;
    }>
> => {
    const data = querystring.stringify({
        ...createPayload(payload),
        webservice: 'ws_MyWayStudio_Get_Departments_Statistics',
    });

    return postProxy<{
        response: string;
        departmentsStatistics: IDepartmentsStatistics[];
        fromDate: string;
        toDate: string;
    }>(getStoreProxyUrl(), data);
};

// FC REQUEST

export const reqGetPassengerAddress = async ({
    dbUrl,
    ...payload
}: {
    dbUrl: string;
    clientCode: string;
    passCode: string;
    token: string;
    pickupTime: string;
    dropTime: string;
}): Promise<
    AxiosResponse<{
        response: string;
        data: { city: string; street: string; houseNum: string }[];
    }>
> => {
    const data = querystring.stringify({
        ...createPayload(payload),
        webservice: 'ws_MyWayStudio_Get_Passenger_Address',
    });

    return postProxy<{ response: string; data: { city: string; street: string; houseNum: string }[] }>(
        getStoreProxyUrl(),
        data
    );
};
